<template>
	<div>
		<layout-5 :id=pageid :empty="'No Unassigned Documents'"></layout-5>
	</div>
</template>

<script>
import {PAGES} from './../../../constants.js'
import api from '@/api'
import router from '@/router/index'
export default {
    props: {
		term: ''
    },
	data(){
		return{
			pageid:PAGES.UNASSIGNED_DOCUMENTS_PAGE
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/view/Unassigned_Documents.vue